export default __webpack_public_path__ + "static/bed-bath-beyond-5-b-aa059f493faff970e8e08591f02c01c9.webp";